<template>
    <div>
		<div class="page-filter-box">
		    <el-row :gutter="20">
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-input v-model="params.word" class="input-with-select" size="small" placeholder="请输入分词">
					</el-input>
				</el-col>
		        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
		            <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
		            <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
		        </el-col>
		    </el-row>
		</div>
        <div v-if="$utils.have('/hotWords/add')" class="page-btns-box">
            <el-button
                type="primary"
                icon="el-icon-plus"
                @click="$refs.Addwords.show(data);"
                size="small"
                >添加分词</el-button
            >
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column
                    prop="words"
                    label="分词"
                ></el-table-column>
                
                <el-table-column
                    prop="createTime"
                    label="添加时间"
                ></el-table-column>
                <el-table-column v-if="$utils.have('/hotWords/del')" fixed="right" label="操作" width="120">
                    <template slot-scope="scope">                        
                        <el-button
                            v-if="$utils.have('/hotWords/del')"
                            type="text"
                            size="small"
                            icon="el-icon-delete"
                            @click="del(scope.row.id,scope.row.words)"
                            >删除</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0"
            >
            </el-pagination>
        </div>
		<add-words ref="Addwords" @update="getDataList"></add-words>
    </div>
</template>
<script>
const defaultParams = {
    pageNo: 1,
    word:''
}
import AddWords from "./components/addwords";
export default {
	components: { AddWords },
    data() {
        return {
            data: null,
            dataList: null,
            params: {
				...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0])				
            },
            listLoading: true,
        };
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/hotWords/list",
                method: "POST",
                params: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        
		//选择pageSize
		handleSizeChange(e) {
		    this.params.pageNo = 1;
		    this.params.pageSize = e;
		    this.getDataList();
		},
		//搜索
		search() {
		    this.params.pageNo = 1;
		    this.getDataList();
		},
		//重置搜索
		reset() {
		    this.params = {
		        ...defaultParams,
		        pageSize: this.params.pageSize,
		    }
		    this.getDataList();
		},
        //编辑
        edit(id) {
            this.$router.replace({
                path: `/system/serviceTemplate/edit/${id}`,
                query: {
                    v:this.$utils.uuid(),
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                },
            });
        },
        //删除事件
        del(id,text){
			const _msg = `<div>确定要删除分词：<span class="color-danger">${text}</span> ?</div>`;
						
						
			this.$confirm(_msg, '删除分词', {	
                center: true,
                closeOnClickModal: false,
                dangerouslyUseHTMLString: true,
                confirmButtonText: "确认删除",
            }).then(() => {
                this.listLoading = true;
                this.$request({
                    url: '/hotWords/del',
                    method: 'POST',
                    params: {id:id}
                }).then(res => {
                    const { state, msg } = res.data;
                    if( state == 1 ){
                        this.getDataList();
                    }else{
                        this.$message.error(msg || '请求失败');
                    }
                }).catch(() => {
                    this.$message.error('请求错误');
                }).finally(() => {
                    this.listLoading = false;
                });
            })
        }
    },
};
</script>